module.exports = __webpack_public_path__ + "static/icons/icon-transfers-0581158cf4b13f874ca11575d1e36852.svg";